import { render } from "./B2bFilterButtonCoacsuRecibidos.vue?vue&type=template&id=5d27f783&scoped=true"
import script from "./B2bFilterButtonCoacsuRecibidos.vue?vue&type=script&lang=js"
export * from "./B2bFilterButtonCoacsuRecibidos.vue?vue&type=script&lang=js"

import "./B2bFilterButtonCoacsuRecibidos.vue?vue&type=style&index=0&id=5d27f783&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d27f783"]])

export default __exports__